import { render, staticRenderFns } from "./unit-data-table.vue?vue&type=template&id=0755d7eb&"
import script from "./unit-data-table.vue?vue&type=script&lang=js&"
export * from "./unit-data-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports